<div
    ng-form="newInterestsNotificationsForm"
    class="container-fluid well"
    data-test-automation="new-interests">
    <h5>{{title}}</h5>
    <div class="row">
        <div class="col-xs-12">
            @if (newInterestsUiConfig) {
                <table class="table table-hover table-striped">
                    <thead>
                        <tr class="default">
                            <td nowrap>{{newInterestsUiConfig.newInterestsTableSubjectColumnLabel}}</td>
                            <td nowrap>{{newInterestsUiConfig.newInterestsTablePurposeColumnLabel}}</td>
                            <td nowrap>{{newInterestsUiConfig.newInterestsTableStatRefColumnLabel}}</td>
                            <td nowrap>{{newInterestsUiConfig.newInterestsTableOriginColumnLabel}}</td>
                            <td nowrap>{{newInterestsUiConfig.newInterestsTableLandBurdenedColumnLabel}}</td>
                            <td nowrap>{{newInterestsUiConfig.newInterestsTableBenefitColumnLabel}}</td>
                            <td nowrap>{{newInterestsUiConfig.newInterestsTableCommentsColumnLabel}}</td>
                            <td
                                nowrap
                                class="custom-header"
                                title="Actions">
                            </td>
                        </tr>
                    </thead>
                    <tbody>
                        @for (newInterestNotification of newInterestsNotifications; track newInterestNotification; let index = $index) {
                            <tr data-test-automation="new-interest">
                                <td class="text-left">{{newInterestNotification.subject}}</td>
                                <td class="text-left">{{newInterestNotification.purpose}}</td>
                                <td class="text-left">{{newInterestNotification.statutoryReference}}</td>
                                <td class="text-left">{{newInterestNotification.origin}}</td>
                                <td class="text-left">
                                    @for (lb of newInterestNotification.landBurdened; track lb) {
                                        <div>{{lb}}</div>
                                    }
                                </td>
                                <td class="text-left">
                                    @for (namedBeneficiary of newInterestNotification.benefitTo.namedBeneficiary; track namedBeneficiary) {
                                        <div>
                                            {{namedBeneficiary}}
                                        </div>
                                    }
                                    @if (newInterestNotification.benefitTo.lotsOnThisPlan.length > 0) {
                                        <div>
                                            {{newInterestsUiConfig.newInterestsBenefitLotsThisPlanSubheading}}
                                            <div>
                                                {{newInterestNotification.benefitTo.lotsOnThisPlan.join(', ')}}
                                            </div>
                                        </div>
                                    }
                                    @if (newInterestNotification.benefitTo.lotsOnOtherPlan.length > 0) {
                                        <div>
                                            {{newInterestsUiConfig.newInterestsBenefitLotsOtherPlanSubheading}}
                                            @for (lotsOnOtherPlan of newInterestNotification.benefitTo.lotsOnOtherPlan; track lotsOnOtherPlan) {
                                                <div> {{lotsOnOtherPlan.planReference}}: {{lotsOnOtherPlan.lots.join(', ')}} </div>
                                            }
                                        </div>
                                    }
                                </td>
                                <td class="text-left">{{newInterestNotification.userEnteredComments}}</td>
                                <td
                                    class="vertical-middle text-right"
                                    style="width: 170px;padding:0px">
                                    @if ((['EDIT_INTERESTS'] | hasPermissions)) {
                                        <div>
                                            @if (getError(newInterestNotification)) {
                                                <span>
                                                    <i
                                                        class="nlrp-icon nlrp-icon-error error"
                                                        title="{{getError(newInterestNotification)}}"></i>
                                                    <input
                                                        type="checkbox"
                                                        class="hidden"
                                                        name="newInterestNotificationError{{index}}"
                                                        value="false"
                                                        required />
                                                </span>
                                            }
                                            <i
                                                class="nlrp-icon nlrp-icon-edit"
                                                title="Edit"
                                                (click)="!isReadonly() && editInterest(newInterestNotification)"
                                                data-test-automation="edit-interest"></i>
                                            <i
                                                class="nlrp-icon nlrp-icon-trash"
                                                title="Delete"
                                                (click)="!isReadonly() && deleteInterest(newInterestNotification)"
                                                data-test-automation="remove-interest"></i>
                                        </div>
                                    }
                                </td>
                            </tr>
                        }
                    </tbody>
                </table>
            }
        </div>
    </div>
    <div class="row mgt0">
        <div class="col-xs-12">
            @if (newInterestsUiConfig && (['EDIT_INTERESTS'] | hasPermissions)) {
                <button
                    id="newInterestsNotificationsAddBtn"
                    type="button"
                    class="btn btn-default nlr-btn-sm validate"
                    (click)="addNewInterest()"
                    [disabled]="isReadonly() || hasInvalidPlanDetails()"
                    title="Add new interest"
                    data-test-automation="add-interest">
                    Add
                    <i
                        class="nlrp-icon nlrp-icon-refresh-reload refresh-animate"
                        style="display: none;"></i>
                </button>
            }
        </div>
    </div>
    @if (newInterestsQuestionDisplay && (['EDIT_INTERESTS','VIEW_INTERESTS'] | hasPermissions)) {
        <div class="row">
            <div class="col-xs-12">
                <label
                    class="control-label required-input"
                    title="An easement must not burden and benefit lots with the same owner, unless there is a transfer of one of the lots as part of the registration of the easement.">
                    Does the burdened and benefit lots for any of the easements created on the plan have the same owner?
                </label>
                <div
                    class="input-group"
                    [ngClass]="{'has-radio-error': newInterestSameOwner | formFieldHasError}">
                    <label class="nlr-radio">
                        <input
                            type="radio"
                            name="newInterestSameOwner"
                            id="newInterestSameOwnerTrue"
                            #newInterestSameOwner="ngModel"
                            [(ngModel)]="model.newInterestSameOwner"
                            [value]="true"
                            required
                            [disabled]="isReadonly() || hasInvalidPlanDetails()" />
                        <span>Yes</span>
                    </label>
                    <label class="nlr-radio">
                        <input
                            type="radio"
                            name="newInterestSameOwner"
                            id="newInterestSameOwnerFalse"
                            #newInterestSameOwner="ngModel"
                            [(ngModel)]="model.newInterestSameOwner"
                            [value]="false"
                            required
                            [disabled]="isReadonly() || hasInvalidPlanDetails()" />
                        <span>No</span>
                    </label>
                </div>
            </div>
        </div>
    }
</div>
<!-- <div class="help-block">
<span>Error!</span>
<span>{{groups.planInformation.invalidNewInterestsNotificationsText}}</span>
</div> -->
